import { SiGoogleanalytics } from "react-icons/si";

export const features = [
  {
    title: "Real-Time Market Data and Analytics",
    paragraph:
      "We  Provide Advanced tools for analyzing market patterns, including candlestick charts, volume indicators, and heatmaps. We also include live updates on cryptocurrency prices, market trends, and historical performance",
    icon: <SiGoogleanalytics />,
  },
  {
    title: "Diversification Made Simple",
    paragraph:
      "Our technology simplifies managing a diversified crypto portfolio for maximum growth and minimized risk",
    icon: <SiGoogleanalytics />,
  },
  {
    title: "Peace of Mind",
    paragraph:
      "Advanced security features ensure users' funds and data are safe from breaches.",
    icon: <SiGoogleanalytics />,
  },
  {
    title: "Accessibility for All Levels",
    paragraph:
      " Our packages are designed to be accessible to users in need of our services and they generate massive returns for investors",
    icon: <SiGoogleanalytics />,
  },
  {
    title: "Real-Time Market Data and Analytics",
    paragraph:
      "We  Provide Advanced tools for analyzing market patterns, including candlestick charts, volume indicators, and heatmaps. We also include live updates on cryptocurrency prices, market trends, and historical performance",
    icon: <SiGoogleanalytics />,
  },
  {
    title: "Real-Time Market Data and Analytics",
    paragraph:
      "We  Provide Advanced tools for analyzing market patterns, including candlestick charts, volume indicators, and heatmaps. We also include live updates on cryptocurrency prices, market trends, and historical performance",
    icon: <SiGoogleanalytics />,
  },
];

export const ShortTermTrading = [
  { investment: "2,400", profit: "4,800" },
  { investment: "2,900", profit: "5,800" },
  { investment: "3,400", profit: "6,800" },
];

export const SignalPackage = [
  { investment: "5,900", profit: "20% Daily" },
  { investment: "7,900", profit: "20% Daily" },
  { investment: "9,900", profit: "20% Daily" },
];

export const LongTermTrading = [
  { investment: "900", profit: "2,700" },
  { investment: "2,300", profit: "6,900" },
  { investment: "3,500", profit: "10,500" },
];

export const PremiumTradingPeriod = [
  { investment: "50,000", profit: "250,000" },
];
